import type { IconName } from '@hotjar/hotsauce';
import type { Device } from '@hotjar/feedback/domain/common/Responses/Device';

export function getDeviceIcon(device: Device): IconName {
  return `device_${device}` as const;
}

export function getBrowserIcon(browser?: string): IconName {
  const defaultIcon = 'unknown';
  if (!browser) return defaultIcon;

  const str = browser.toLowerCase();
  if (str.indexOf('android') > -1) return 'android';
  if (str.indexOf('chrome') > -1) return 'chrome';
  if (str.indexOf('chromium') > -1) return 'chromium';
  if (str.indexOf('blackberry') > -1) return 'blackberry';
  if (str.indexOf('firefox') > -1) return 'firefox';
  if (str.indexOf('ie') > -1) return 'ms_ie';
  if (str.indexOf('edge') > -1) return 'edge';
  if (str.indexOf('opera') > -1) return 'opera';
  if (str.indexOf('safari') > -1) return 'safari';
  return defaultIcon;
}

export function getSystemIcon(os?: string): IconName {
  const defaultIcon = 'unknown';
  if (!os) return defaultIcon;

  const str = os.toLowerCase();
  if (str.indexOf('android') > -1) return 'android';
  if (str.indexOf('blackberry') > -1) return 'blackberry';
  if (str.indexOf('chrome') > -1) return 'chrome';
  if (str.indexOf('ios') > -1 || str.indexOf('os x') > -1 || str.indexOf('mac') > -1)
    return 'apple';
  if (str.indexOf('linux') > -1) return 'linux';
  if (str.indexOf('ubuntu') > -1) return 'ubuntu';
  if (str.indexOf('windows') > -1) return 'windows';
  return defaultIcon;
}
